<template>
    <flex-element :element-type="elementType" class="f-inline-block f-self-start f-cursor-hover">
        <select
            v-model="selected"
            class="f-w-1/1 f-h-1/1 f-bg-transparent"
            :name="inputName"
            :required="required"
            :aria-label="ariaLabel"
            :aria-labelledby="ariaLabelledBy"
            @input="onInput"
            @invalid="onInvalidInput"
            @change="changeEvent"
        >
            <option
                v-if="placeholder"
                value=""
                selected
            >
                {{ placeholder }}
            </option>

            <option
                v-for="(value, key) in computedOptions"
                :key="value"
                :value="value"
            >
                {{ key }}
            </option>
        </select>
    </flex-element>
</template>

<script>
import jsonpath from 'jsonpath';
import { mapMutations } from 'vuex';
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import { FIRE_FLEX_EVENT } from '@/store/types/mutation-types';
import selectDataQuery from '@/graphql/queries/SelectData.gql';

export default {
    name: 'a-select',
    mixins: [baseAtom],

    apollo: {
        itemData: {
            query: selectDataQuery,

            variables() {
                return {
                    dataSourceId: this.datasourceValue,
                };
            },

            update(data) {
                if (!data || !data.item) return [];

                return data.item.children;
            },

            skip() {
                return !this.datasourceValue;
            },
        },
    },

    props: {
        inputName: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },

        options: {
            type: Object,
            required: true,
        },

        required: {
            type: Boolean,
            default: false,
        },

        validationMessage: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            inputValueNew: '', // don't remove, needed for the "set cookie" logic in o-form-container
            selected: '',
        };
    },

    computed: {
        datasourceValue() {
            return this.getElementData('selectDatasource');
        },

        datasourceTextPath() {
            return this.getElementData('selectTextPath');
        },

        datasourceValuePath() {
            return this.getElementData('selectValuePath');
        },

        computedOptions() {
            if (this.itemData && this.itemData.length > 0) {
                const namePath = this.datasourceTextPath || '$.name';
                const valuePath = this.datasourceValuePath || '$.fields[0].value';
                return Object.assign({}, ...this.itemData.map(object => ({ [jsonpath.query(object, namePath)[0]]: jsonpath.query(object, valuePath)[0] })));
            }
            return this.options;
        },
    },

    watch: {
        computedOptions() {
            if (this.datasourceValue) {
                this.preselectData();
            }
        },
    },

    mounted() {
        if (!this.datasourceValue) {
            this.preselectData();
        }
    },

    methods: {
        ...mapMutations({
            fireFlexEvent: FIRE_FLEX_EVENT,
        }),

        preselectData() {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.forEach((value, key) => {
                if (this.inputName === key) {
                    const splitValues = value.split('|');
                    splitValues.forEach((sv) => {
                        if (Object.values(this.computedOptions).filter(ov => ov === sv).length > 0) {
                            this.selected = sv;
                        }
                    });
                }
            });
        },

        onInput(e) {
            e.target.setCustomValidity('');
            this.inputValueNew = e.target.value;
        },

        onInvalidInput(e) {
            e.target.setCustomValidity(this.validationMessage);
        },

        changeEvent(e) {
            this.fireFlexEvent(`change-${ this.inputNameNew }`);
            this.fireFlexEvent(`change-${ this.inputNameNew }-${ e.target.value }`);

            if (this.getElementData('selectAutoSubmit') === 'true') {
                this.$emit('submit-form');
            }
        },
    },
};
</script>
